import { useState } from "react";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useMutation } from "react-query";
import { API } from "../../config/api";

import heroImage from "../../assets/img/hero-image.png";

function Register() {
  document.title = "Register";

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [message, setMessage] = useState();

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const body = JSON.stringify(form);

      const response = await API.post("/register", body, config);

      if (response.data.status === "success") {
        const alert = (
          <Alert variant="success" className="py-1">
            Register Success, silahkan login
          </Alert>
        );
        setMessage(alert);
        setForm({
          name: "",
          email: "",
          password: "",
        });
      } else {
        const alert = (
          <Alert variant="warning" className="py-1">
            Failed
          </Alert>
        );
        setMessage(alert);
      }
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <Container className="register-section">
        <Row>
          <Col md={6} className="mb-5">
            <img src={heroImage} alt="heroImage" className="hero-image my-4" />
            <h1>Easy, Fast and Reliable</h1>
            <p className="text-muted mb-5">
              Go shopping for merchandise, just go to dumb merch shopping. the
              biggest merchandise in <strong>Indonesia</strong>
            </p>
            <div>
              <Link to="/" className="fw-bold link-login">
                Login
              </Link>
              <a href="/register" className="link-register fw-bold">
                Register
              </a>
            </div>
          </Col>

          <Col
            md={6}
            className="d-flex align-items-center justify-content-center"
          >
            <Card className="card-register p-4">
              <h3 className="fw-bold my-3">Register</h3>
              {message && message}
              <form onSubmit={(e) => handleSubmit.mutate(e)}>
                <input
                  type="name"
                  className="form-control name-register my-4"
                  name="name"
                  placeholder="Name"
                  onChange={handleChange}
                  value={form.name}
                />
                <input
                  type="email"
                  className="form-control email-register mb-4"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={form.email}
                />
                <input
                  type="password"
                  className="form-control password-register mb-5"
                  name="password"
                  placeholder="Password"
                  onChange={handleChange}
                  value={form.password}
                />
                <Button type="submit" className="fw-bold btn-register w-100">
                  Register
                </Button>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Register;
